import { render, staticRenderFns } from "./AssignValidatorsPanel.vue?vue&type=template&id=320c6994&scoped=true&"
import script from "./AssignValidatorsPanel.vue?vue&type=script&lang=js&"
export * from "./AssignValidatorsPanel.vue?vue&type=script&lang=js&"
import style0 from "./AssignValidatorsPanel.vue?vue&type=style&index=0&id=320c6994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320c6994",
  null
  
)

export default component.exports